<template>
  <div class="m-bossblitz" :class="{ 'is-sticky': isSticky }">
    <div id="hero" class="m-bossblitz__hero" ref="hero">
      <img :src="require(`@/assets/images/microsites/bossblitz/hero/${bannerView}.jpg`)" />
      <div @click="scrollToId('how-to-earn', 'Unlock Twitch Drops')" class="unlock-twitch">
        <span>Unlock Twitch Drops</span>
      </div>
    </div>

    <div class="m-bossblitz__menu">
      <div v-if="isSticky" class="unlock-twitch-wrapper">
        <div
          @click="scrollToId('how-to-earn', `${isSticky ? 'Sticky ' : ''}Unlock Twitch Drops`)"
          class="unlock-twitch"
        >
          <span>Unlock Twitch Drops</span>
        </div>
      </div>

      <div @click="scrollToId('about', `${isSticky ? 'Sticky ' : ''}Menu > About`)" class="m-bossblitz__menu__item">
        About
      </div>
      <!-- <div @click="scrollToId('stream', `${isSticky ? 'Sticky ' : ''}Menu > Stream`)" class="m-bossblitz__menu__item">
        Stream
      </div> -->
      <div @click="scrollToId('teams', `${isSticky ? 'Sticky ' : ''}Menu > Teams`)" class="m-bossblitz__menu__item">
        Teams
      </div>
      <div
        @click="scrollToId('schedule', `${isSticky ? 'Sticky ' : ''}Menu > Schedule`)"
        class="m-bossblitz__menu__item"
      >
        Schedule
      </div>
      <div
        @click="scrollToId('twitch-drops', `${isSticky ? 'Sticky ' : ''}Menu > Twitch Drops`)"
        class="m-bossblitz__menu__item"
      >
        Twitch Drops
      </div>
    </div>

    <!-- About -->
    <div id="about" class="m-bossblitz__section m-bossblitz__about">
      <div class="m-bossblitz__about__wrapper">
        <p class="m-bossblitz__p">
          The MapleStory <span class="m-bossblitz__bold">Boss Blitz</span> is a special event featuring talented gamers
          who are new to MapleStory as they learn how to play, get the lay of the land, and build up their skills. Three
          teams will then join us for a live competition during MapleStory Fest 2022 as they challenge each other to see
          which team has mastered MapleStory!
        </p>

        <p class="m-bossblitz__p">
          Each team is made up of two streamers who are new to MapleStory, guided through their adventures in Maple
          World by a mentor from our Bean Brigade. Over the next few weeks, these teams will meet up on Twitch, learning
          all the ins and outs of MapleStory with the help of their coach.
        </p>

        <p class="m-bossblitz__p">
          Watch their livestreams to unlock special MapleStory rewards themed after the Boss Blitz teams, enjoy seeing
          them dive headfirst into all the fun, and join us for MapleStory Fest 2022 to see their newly-learned
          skills&nbsp;pay&nbsp;off!
        </p>
      </div>
    </div>

    <!-- Stream -->
    <!-- <div id="stream" class="m-bossblitz__section m-bossblitz__stream">
      <div class="m-bossblitz__section__title"><span>Stream</span></div>

      <div
        class="m-bossblitz__stream__wrapper"
        v-observe-visibility="{
          callback: streamVisibility,
          intersection: { rootMargin: rootMarginValue },
          throttle: 500,
          once: true,
        }"
      >
        <div v-if="streamIsLive && streamChannel" class="m-bossblitz__stream__live">
          <div v-if="streamTitle" class="m-bossblitz__stream__live__name">
            {{ streamTitle }}
          </div>

          <div class="m-bossblitz__stream__live__container">
            <iframe
              :src="`https://player.twitch.tv/?channel=${streamChannel}&parent=${hostname}`"
              frameborder="0"
              allowfullscreen="true"
              scrolling="no"
            ></iframe>
          </div>

          <a
            :href="`https://www.twitch.tv/${streamChannel}`"
            target="_blank"
            class="m-bossblitz__stream__live__description"
            @click="clickTracking('Watch On Twitch')"
            >Watch on Twitch to earn Twitch Drop rewards!</a
          >
        </div>

        <div v-else class="m-bossblitz__stream__check-schedule">
          Check the <span @click="scrollToId('schedule', 'Stream Schedule')">schedule</span> below to see when our teams
          are&nbsp;scheduled to practice!
        </div>
      </div>
    </div> -->

    <!-- Teams -->
    <div id="teams" class="m-bossblitz__section m-bossblitz__teams">
      <div class="m-bossblitz__section__title"><span>Teams</span></div>

      <div
        class="m-bossblitz__teams__wrapper"
        v-observe-visibility="{
          callback: teamsVisibility,
          intersection: { rootMargin: rootMarginValue },
          throttle: 500,
          once: true,
        }"
      >
        <!-- All teams -->
        <div class="m-bossblitz__section__description">
          Check out the players who will be competing during MapleStory Fest 2022, and the coaches that will be
          guiding them through their adventures in Maple World!
        </div>

        <div v-for="team in teams" class="m-bossblitz__teams__team" :class="{'m-bossblitz__teams__team--winner': team.isWinner}" :key="team.class">
          <div v-if="team.isWinner" class="m-bossblitz__teams__team__winner-title">
            <span>Congratulations to </span>
            <span :class="team.class">{{ team.name }}</span
            >!
          </div>

          <div v-else class="m-bossblitz__teams__team__logo" :class="`m-bossblitz__teams__team__logo--${team.class}`"></div>

          <div class="m-bossblitz__teams__team__member" v-for="(member, index) in team.members" :key="index">
            <div class="m-bossblitz__teams__team__member__image">
              <img
                :src="require(`@/assets/images/microsites/bossblitz/teams/${team.class}/${member.image}.png`)"
                alt=""
              />
            </div>

            <div class="m-bossblitz__teams__team__member__info">
              <div class="m-bossblitz__teams__team__member__info__title">
                <span :class="team.class">{{ member.type }}</span> {{ member.name }}
              </div>

              <div class="m-bossblitz__teams__team__member__info__intro" :class="team.class">
                {{ member.description }}
              </div>
            </div>

            <div v-if="member.socials" class="m-bossblitz__teams__team__member__socials">
              <a
                v-for="(social, socialIndex) in member.socials"
                :href="social.link"
                :key="socialIndex"
                target="_blank"
                @click="clickTracking(`${team.isWinner ? `Winning Player ${index + 1} > ${social.label}` : `${team.name} Player ${index + 1} > ${social.label}`}`)"
              >
                <i class="icon fab" :class="social.icon"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="m-bossblitz__vote">
          <div class="m-bossblitz__vote__title">Vote for your Favorite Team!</div>
          <div class="m-bossblitz__vote__description">New MapleStory players* can vote for their favorite streamers' team to give them a special leg-up in the live competition at MapleStory Fest! Teams will get the following items to power them up during the final challenge based on the number of votes they've received:</div>

          <div class="m-bossblitz__vote__item-wrapper">
            <div class="m-bossblitz__vote__item">
              <div class="m-bossblitz__vote__item__title">
                200 Team Votes
              </div>

              <div class="m-bossblitz__vote__item__left">
                <div class="m-bossblitz__vote__item__left__img m-bossblitz__vote__item__left__img--200"></div>
                <div>
                  <div>Extreme Red Potion</div>
                  <div>(ATK +30, 30 minutes) (x4&nbsp;each)</div>
                </div>
              </div>
              <div class="m-bossblitz__vote__item__right">
                <div class="m-bossblitz__vote__item__right__img m-bossblitz__vote__item__right__img--200"></div>
                <div>
                  <div>Extreme Green Potion</div>
                  <div>(Attack Speed Increase, 30&nbsp;minutes) (4x each)</div>
                </div>
              </div>
            </div>
          </div>

          <div class="m-bossblitz__vote__item-wrapper">
            <div class="m-bossblitz__vote__item">
              <div class="m-bossblitz__vote__item__title">
                400 Team Votes
              </div>

              <div class="m-bossblitz__vote__item__left">
                <div class="m-bossblitz__vote__item__left__img m-bossblitz__vote__item__left__img--400"></div>
                <div>200 Votes Rewards</div>
              </div>
              <div class="m-bossblitz__vote__item__right">
                <div class="m-bossblitz__vote__item__right__img m-bossblitz__vote__item__right__img--400"></div>
                <div>
                  <div>Sparkling Blue Star Potion</div>
                  <div>(Ignore DEF 20%, 2 hours) (1x&nbsp;each)</div>
                </div>
              </div>
            </div>
          </div>

          <div class="m-bossblitz__vote__item-wrapper">
            <div class="m-bossblitz__vote__item m-bossblitz__vote__item--3">
              <div class="m-bossblitz__vote__item__title">
                600 Team Votes
              </div>

              <div class="m-bossblitz__vote__item__left">
                <div class="m-bossblitz__vote__item__left__img m-bossblitz__vote__item__left__img--600"></div>
                <div>400 Votes Rewards</div>
              </div>
              <div class="m-bossblitz__vote__item__right">
                <div class="m-bossblitz__vote__item__right__img m-bossblitz__vote__item__right__img--600"></div>

                <div>
                  <div>Red Star Potion</div>
                  <div>(Boss Attack 20%, 2 hours) (1x each)</div>
                </div>
              </div>
            </div>
          </div>

          <div class="m-bossblitz__vote__subtitle"><i>* New MapleStory Players:</i> Accounts created between 3:00 PM UTC on October 20, 2022 and 11:59 PM UTC on November 13, 2022</div>
        </div>
      </div>
    </div>

    <!-- Practice Schedule -->
    <div id="schedule" class="m-bossblitz__section m-bossblitz__schedule">
      <div class="m-bossblitz__section__title m-bossblitz__section__title--type2"><span>Practice Schedule</span></div>

      <div
        class="m-bossblitz__schedule__wrapper"
        v-observe-visibility="{
          callback: practiceScheduleVisibility,
          intersection: { rootMargin: rootMarginValue },
          throttle: 500,
          once: true,
        }"
      >
        <div class="m-bossblitz__section__description">
          Check out when each of the teams will be meeting up to learn MapleStory!
        </div>

        <div class="m-bossblitz__schedule__table">
          <div class="m-bossblitz__schedule__table__column m-bossblitz__schedule__table__column">
            <div class="streams pink">
              <div class="streams__day"><span class="m-bossblitz__semibold">Stream 1</span> = Oct 24 at 3 PM PDT</div>
              <div class="streams__day"><span class="m-bossblitz__semibold">Stream 2</span> = Nov 1 at 3 PM PDT</div>
              <div class="streams__day"><span class="m-bossblitz__semibold">Stream 3</span> = Nov 7 at 4 PM PDT</div>
            </div>
          </div>
          <div class="m-bossblitz__schedule__table__column m-bossblitz__schedule__table__column">
            <div class="streams orange">
              <div class="streams__day"><span class="m-bossblitz__semibold">Stream 1</span> = Oct 27 at 1:30 PM PDT</div>
              <div class="streams__day"><span class="m-bossblitz__semibold">Stream 2</span> = Nov 4 at 1:30 PM PDT</div>
              <div class="streams__day"><span class="m-bossblitz__semibold">Stream 3</span> = Nov 8 at 1:30 PM PDT</div>
            </div>
          </div>
          <div class="m-bossblitz__schedule__table__column m-bossblitz__schedule__table__column">
            <div class="streams green">
              <div class="streams__day"><span class="m-bossblitz__semibold">Stream 1</span> = Oct 28 at 10 AM PDT</div>
              <div class="streams__day"><span class="m-bossblitz__semibold">Stream 2</span> = Nov 3 at 1:30 PM PDT</div>
              <div class="streams__day"><span class="m-bossblitz__semibold">Stream 3</span> = Nov 9 at 10 AM PDT</div>
            </div>
          </div>
          <div class="m-bossblitz__schedule__table__column m-bossblitz__schedule__table__column">
            <div class="streams final">
              <div class="streams__day">Saturday, November 12 at&nbsp;MapleStory Fest!</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Practice Schedule -->
    <div id="twitch-drops" class="m-bossblitz__section m-bossblitz__twitch-drops">
      <div class="m-bossblitz__section__title m-bossblitz__section__title--type3">
        <span>MapleStory Boss Blitz Twitch Drops</span>
      </div>

      <div
        class="m-bossblitz__twitch-drops__wrapper"
        v-observe-visibility="{
          callback: twitchDropsVisibility,
          intersection: { rootMargin: rootMarginValue },
          throttle: 500,
          once: true,
        }"
      >
        <div class="m-bossblitz__section__description">
          Watch your favorite streamer on Twitch during their practice sessions and earn Twitch Drops themed after their
          team! Check&nbsp;out&nbsp;the&nbsp;available rewards below!
        </div>

        <div class="m-bossblitz__twitch-drops__rewards">
          <div class="m-bossblitz__twitch-drops__rewards__reward-container">
            <div class="m-bossblitz__twitch-drops__rewards__reward pink">
              <div class="m-bossblitz__twitch-drops__rewards__reward__title">
                <div>Team Pink Bean</div>
                <div>Chair and Headset</div>
              </div>

              <div class="m-bossblitz__twitch-drops__rewards__reward__img-container">
                <div class="m-bossblitz__twitch-drops__rewards__image"></div>
              </div>
              <div class="m-bossblitz__twitch-drops__rewards__reward__details">
                <ul>
                  <li><span>Watch Team Pink Bean Streamers for a total of <span class="pink">3 hours</span> to claim the <span class="pink">Pink Bean Headset</span> item!</span></li>
                  <li><span>Watch Team Pink Bean Streamers for a total of <span class="pink">4 hours</span> to claim the <span class="pink">Pink Bean Chair</span> item!</span></li>
                </ul>
              </div>
            </div>
          </div>

          <div class="m-bossblitz__twitch-drops__rewards__reward-container">
            <div class="m-bossblitz__twitch-drops__rewards__reward green">
              <div class="m-bossblitz__twitch-drops__rewards__reward__title">
                <div>Team Green Slime</div>
                <div>Chair and Headset</div>
              </div>

              <div class="m-bossblitz__twitch-drops__rewards__reward__img-container">
                <div class="m-bossblitz__twitch-drops__rewards__image"></div>
              </div>

              <div class="m-bossblitz__twitch-drops__rewards__reward__details">
                <ul>
                  <li><span>Watch Team Green Slime Streamers for a total of <span class="green">3 hours</span> to claim the <span class="green">Green Slime Headset</span> item!</span></li>
                  <li><span>Watch Team Green Slime Streamers for a total of <span class="green">4 hours</span> to claim the <span class="green">Green Slime Chair</span> item!</span></li>
                </ul>
              </div>
            </div>
          </div>

          <div class="m-bossblitz__twitch-drops__rewards__reward-container">
            <div class="m-bossblitz__twitch-drops__rewards__reward orange">
              <div class="m-bossblitz__twitch-drops__rewards__reward__title">
                <div>Team Orange Mushroom</div>
                <div>Chair and Headset</div>
              </div>

              <div class="m-bossblitz__twitch-drops__rewards__reward__img-container">
                <div class="m-bossblitz__twitch-drops__rewards__image"></div>
              </div>

              <div class="m-bossblitz__twitch-drops__rewards__reward__details">
                <ul>
                  <li><span>Watch Team Orange Mushroom Streamers for a total of <span class="orange">3 hours</span> to claim the <span class="orange">Orange Mushroom Headset</span> item!</span></li>
                  <li><span>Watch Team Orange Mushroom Streamers for a total of <span class="orange">4 hours</span> to claim the <span class="orange">Orange Mushroom Chair</span> item!</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="m-bossblitz__twitch-drops__rewards-details">
          These rewards will last for 90 days, and existing MapleStory players* can get permanent versions of them by logging in 18 days during the Boss Blitz event (October 20 - November 13)! New MapleStory players* that collect these rewards will also receive permanent versions by logging in once during the campaign period, and these rewards will be distributed during a future in-game Gift Drop.
        </div>

        <div id="how-to-earn" class="m-bossblitz__twitch-drops__how-to">
          <div class="m-bossblitz__twitch-drops__how-to__title">How to Earn Twitch Drops</div>
          <div id="link-your-account" class="m-bossblitz__twitch-drops__how-to__info">
            Link your Nexon account with Twitch in order to start earning your Twitch Drops!
          </div>

          <div class="m-bossblitz__twitch-drops__how-to__steps">
            <div class="m-bossblitz__twitch-drops__how-to__steps__step">
              <div class="m-bossblitz__twitch-drops__how-to__steps__step__title">1: Link</div>
              <div class="m-bossblitz__twitch-drops__how-to__steps__step__info">
                Sign into your Nexon Account and “Link” your Twitch account
              </div>
            </div>
            <div class="m-bossblitz__twitch-drops__how-to__steps__step">
              <div class="m-bossblitz__twitch-drops__how-to__steps__step__title">2: Watch</div>
              <div class="m-bossblitz__twitch-drops__how-to__steps__step__info">
                Watch MapleStory Twitch Streams with the "Drops Enabled" Tag
              </div>
            </div>
            <div class="m-bossblitz__twitch-drops__how-to__steps__step">
              <div class="m-bossblitz__twitch-drops__how-to__steps__step__title">3: Claim</div>
              <div class="m-bossblitz__twitch-drops__how-to__steps__step__info">
                Claim your Twitch Drops Rewards in-game with MapleStory!
              </div>
            </div>
          </div>

          <div class="m-bossblitz__twitch-drops__how-to__more">
            <!-- Learn more about Twitch Drops and Account Linking at our
            <a
              href="https://support.nexon.net/hc/en-us/articles/360001314823-Linking-Unlinking-Nexon-and-Twitch-Accounts"
              target="_blank"
              @click="clickTracking('Player Support')"
              >Player Support page</a
            >! -->

            <div>
              <a class="m-bossblitz__twitch-drops__how-to__more__link-twitch" href="https://support.nexon.net/hc/en-us/articles/360001314823-Linking-Unlinking-Nexon-and-Twitch-Accounts"
                target="_blank" @click="clickTracking('Player Support')">
                <span>Link your Twitch Account</span>
              </a>
            </div>
          </div>
          
          <div class="m-bossblitz__twitch-drops__how-to__footnotes">
            <div><i>* Existing MapleStory Players:</i> Accounts created prior to 3:00 PM UTC on October 20, 2022</div>
            <div><i>* New MapleStory Players:</i> Accounts created between 3:00 PM UTC on October 20, 2022 and 11:59 PM UTC on November 13, 2022</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="displayScrollToTop" @click="scrollToId('hero')" class="m-bossblitz__scroll-top" />

    <Footer
      color="#C8C1C1"
      hoverColor="#53BBA8"
      backgroundColor="#261617"
      @go-to-main-click="clickTracking('Main Site')"
    />
  </div>
</template>

<script>
import Responsive from '@/services/browser/Responsive'
import Footer from '@/components/microsites/Footer.vue'
import teams from './teams'
import '@/assets/scss/microsites/bossblitz/_bossblitz.scss'
import axios from 'axios'
import { defineComponent } from 'vue'
import { ObserveVisibility } from 'vue-observe-visibility'

export default defineComponent({
  directives: {
    'observe-visibility': ObserveVisibility,
  },
  name: 'Microsite BossBlitz',
  components: {
    Footer,
  },
  props: {},
  data() {
    return {
      teams,
      clientWidth: 0,
      clientHeight: 0,
      scrollY: 0,
      isSticky: false,
      streamChannel: '',
      streamTitle: '',
      streamIsLive: false,
    }
  },
  computed: {
    hostname() {
      return window.location.hostname
    },
    bannerView() {
      if (this.clientWidth <= 479) {
        return 'mobile'
      } else if (this.clientWidth <= 1024) {
        return 'tablet'
      }
      return 'desktop'
    },
    displayScrollToTop() {
      return this.scrollY > this.clientHeight / 2
    },
    winner() {
      return this.teams.find((team) => team.isWinner)
    },
    rootMarginValue() {
      return this.clientWidth <= 510 ? '-100px' : this.clientWidth <= 1024 ? '-200px' : '-150px'
    },
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted() {
    
    Responsive.init()
    this.handleResize()
    this.handleScroll()
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
    // this.getTwitchData()
  },
  methods: {
    async getTwitchData() {
      for (;;) {
        const response = await axios.get(`${process.env.VUE_APP_UMBRACO}/v1/maplestory/influencer-competition.json`)

        this.streamChannel = response.data.twitchChannel
        this.streamTitle = response.data.title
        const now = new Date()
        this.streamIsLive = now >= new Date(response.data.startDate) && now < new Date(response.data.endDate)

        await new Promise((resolve) => setTimeout(resolve, 2 * 1000))
      }
    },
    handleResize() {
      this.clientWidth =
        document.body.clientWidth ||
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
      this.clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    },
    handleScroll() {
      this.scrollY = window.scrollY
      this.$nextTick(() => {
        let heroHeight = this.$refs.hero.clientHeight
        if (heroHeight > 0) {
          this.scrollY >= heroHeight - 2 ? (this.isSticky = true) : (this.isSticky = false)
        }
      })
    },
    scrollToId(id, trackLabel) {
      this.$nextTick(() => {
        this.clickTracking(trackLabel)
        document.getElementById(id).scrollIntoView({
          behavior: 'smooth',
        })
      })
    },
    clickTracking(element) {
      window.dataLayer.push({
        event: 'Transition Event',
        ec: 'Boss Blitz - Microsite',
        ea: 'click',
        el: element,
      })
    },
    viewTracking(element) {
      window.dataLayer.push({
        event: 'Element View', //this is a different event name
        ec: 'Boss Blitz - Microsite',
        ea: 'view',
        el: element,
        noninteraction: true,
      })
    },
    streamVisibility(isVisible) {
      if (isVisible) this.viewTracking(`Stream ${this.streamIsLive ? 'Live' : 'Not Live'}`)
    },
    teamsVisibility(isVisible) {
      if (isVisible) this.viewTracking('Teams')
    },
    practiceScheduleVisibility(isVisible) {
      if (isVisible) this.viewTracking('Schedule')
    },
    twitchDropsVisibility(isVisible) {
      if (isVisible) this.viewTracking('Twitch Drops')
    },
  },
})
</script>
